// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import {
  SET_ADD_TO_HISTORY, SET_BTN_EXPORT, SET_FILE_NO_DATA, SET_OPEN_MODAL_EXPORT_QUERY,
} from '../actions/menuButton';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  history: [],
  openModalExportQuery: false,
  btnExport: false,
  fileNoData: false,
};

function menuButtonReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ADD_TO_HISTORY:
      return {
        ...state,
        history: action.value,
      };
    case SET_OPEN_MODAL_EXPORT_QUERY:
      return {
        ...state,
        openModalExportQuery: action.value,
      };
    case SET_BTN_EXPORT:
      return {
        ...state,
        btnExport: action.value,
      };
    case SET_FILE_NO_DATA:
      return {
        ...state,
        fileNoData: action.value,
      };
    default:
      return state;
  }
}

export default menuButtonReducer;
